module.exports = __webpack_public_path__ + "static/media/babySit.c92a596d.png";